<template>
    <div id="header">
      <template v-if="!hasTransactionShow">
        <router-link :to="{ name: 'Personal'}">        
          <div class="eureko-logo-white logo">
            <div v-if="isEnvTest || isEnvPreProd" :class="envLogo" class="env"></div>
          </div>
        </router-link>
      </template>
      <template v-else>
        <router-link :to="{ name: 'AgencyPersonal'}">
          <div class="eureko-logo-white logo">
            <div v-if="isEnvTest || isEnvPreProd" :class="envLogo" class="env"></div>
          </div>
        </router-link>
      </template>
      <div v-if="hasTransactionShow" class="transactions">
        <el-popover
          :visible="parentVisible"
          placement="bottom"
          width="200"
          trigger="click">
          <button slot="reference" type="button" class="button is-primary is-fullwidth is-medium">{{ $t('links.transactions') }}<i class="fa fa-chevron-down"></i></button>
          <div class="columns is-multiline transaction-items">
            <div class="column is-12">
              <div class="columns">
                <div class="column is-2"><div class="sliders-icon"></div></div>
                <div class="column is-8">
                  <router-link :to="{ name: 'AgencyPersonal'}">
                    <div class="item-text">Dashboard</div>
                  </router-link>
                </div>
                <div class="column is-2"><div><i class="fa fa-chevron-right"></i></div></div>
              </div>
            </div>
            <div class="column is-12" v-if="isUploadDemandActive">
              <div class="columns">
                <div class="column is-2"><div class="plusCircle-icon"></div></div>
                <div class="column is-8">
                  <router-link :to="{ name: 'AgencyNewRequest'}">
                    <div class="item-text">Yeni Talep</div>
                  </router-link>
                </div>
                <div class="column is-2"><div><i class="fa fa-chevron-right"></i></div></div>
              </div>
            </div>
            <div class="column is-12" v-if="isListDemandActive">
              <div class="columns">
                <div class="column is-2"><div class="note-icon"></div></div>
                <div class="column is-8">
                  <router-link :to="{ name: 'AgencyRequestTrack'}">
                    <div class="item-text">Taleplerim</div>
                  </router-link>
                </div>
                <div class="column is-2"><div><i class="fa fa-chevron-right"></i></div></div>
              </div>
            </div>
            <div class="column is-12" v-if="isPolicyRenewalListActive">
              <div class="columns">
                <div class="column is-2"><div class="archive-box-icon"></div></div>
                <div class="column is-8">
                  <el-popover
                    :visible="childVisible"
                    placement="bottom-end"
                    width="260"
                    trigger="click">
                    <div slot="reference" class="item-text">Listeler</div>
                    <div class="columns is-multiline transaction-items">
                      <div class="column is-12">
                        <div class="columns">
                          <div class="column is-2"><div class="archive-box-icon"></div></div>
                          <div class="column is-8">
                            	<modal :width="400" :is-show="policyListShow" :show-footer=false transition="fadeDown" @close="policyListShow=false">
                                <div class="columns is-multiline">
                                  <div class="column is-12">
                                    <div class="agency-policy-list-modal-title">Poliçe Üretim Listesi</div>
                                  </div>
                                  <div class="column is-12">
                                    <div class="agency-policy-list-modal-desc">İndirmek istediğiniz dönemi seçerek, Excel formatında dışarı aktarabilirsiniz.</div>
                                  </div>
                                  <div v-if="policyUpdateDate" class="column is-12">
                                    <div class="agency-policy-list-modal-desc">Güncelleme Tarihi: {{ policyUpdateDate }}</div>
                                  </div>
                                  <template v-if="customer">
                                    <div class="field column is-12">
                                      <label for='year'>{{ $t("texts.branch") }}</label>
                                      <div class='select is-fullwidth'>
                                        <select v-model='branch' :class="{'input': true, 'is-danger': errors.has($t('texts.branch')) }" :name="$t('texts.branch')" v-validate="'required'">
                                          <option disabled value='' selected>{{ $t("buttons.select") }}</option>
                                          <option value='99'>{{ $t("texts.all") }}</option>
                                          <option v-for='[key, value] in branches' :value='key' :key='key'>{{ value }}</option>
                                        </select>
                                        <span class="help is-danger">{{ errors.first($t('texts.branch')) }}</span>
                                      </div>
                                    </div>
                                    <div class="field column is-12">
                                      <label for='year'>{{ $t("texts.term") }}</label>
                                      <div class='select is-fullwidth'>
                                        <select v-model='policyTerm' :disabled="policyTerms.length === 0" :class="{'disabled': policyTerms.length === 0, 'input': true, 'is-danger': errors.has($t('texts.term')) }" :name="$t('texts.term')" v-validate="'required'">
                                          <option disabled value='' selected>{{ $t("buttons.select") }}</option>
                                          <!-- <option :value="new Date().getFullYear()(new Date().getMonth()).toString().padStart(2, '0')">2025/03</option> -->
                                          <option v-for='item in policyTerms' :value='item.value' :key='item.value'>{{ item.title }}</option>
                                        </select>
                                        <span class="help is-danger">{{ errors.first($t('texts.term')) }}</span>
                                      </div>
                                    </div>
                                  </template>
                                  <div class="column data-update-button">
                                    <button type="button" class="button is-primary is-fullwidth is-medium" @click="getAgencyPolicies(false)">Excel Olarak İndir</button>
                                  </div>
                                </div>
                              </modal>
                            <div class="item-text" v-on:click="openPolicyListPopUp(false)">Poliçe Üretim Listesi</div>
                          </div>
                          <div class="column is-2"><div><i class="fa fa-chevron-right"></i></div></div>
                        </div>
                      </div>
                      <div class="column is-12">
                        <div class="columns">
                          <div class="column is-2"><div class="note-icon"></div></div>
                          <div class="column is-8">
                            	<modal :width="400" :is-show="policyRenewalListShow" :show-footer=false transition="fadeDown" @close="policyRenewalListShow=false">
                                <div class="columns is-multiline">
                                  <div class="column is-12">
                                    <div class="agency-policy-list-modal-title">Poliçe Yenileme Listesi</div>
                                  </div>
                                  <div class="column is-12">
                                    <div class="agency-policy-list-modal-desc">İndirmek istediğiniz dönemi seçerek, Excel formatında dışarı aktarabilirsiniz.</div>
                                  </div>
                                  <div v-if="policyUpdateDate" class="column is-12">
                                    <div class="agency-policy-list-modal-desc">Güncelleme Tarihi: {{ policyUpdateDate }}</div>
                                  </div>
                                  <template v-if="customer">
                                    <div class="field column is-12">
                                      <label for='year'>{{ $t("texts.branch") }}</label>
                                      <div class='select is-fullwidth'>
                                        <select v-model='branch' :class="{'input': true, 'is-danger': errors.has($t('texts.branch')) }" :name="$t('texts.branch')" v-validate="'required'">
                                          <option disabled value='' selected>{{ $t("buttons.select") }}</option>
                                          <option value='99'>{{ $t("texts.all") }}</option>
                                          <option v-for='[key, value] in branches' :value='key' :key='key'>{{ value }}</option>
                                        </select>
                                        <span class="help is-danger">{{ errors.first($t('texts.branch')) }}</span>
                                      </div>
                                    </div>
                                    <div class="field column is-12">
                                      <label for='year'>{{ $t("texts.term") }}</label>
                                      <div class='select is-fullwidth'>
                                        <select v-model='policyTerm' :disabled="policyTerms.length === 0" :class="{'disabled': policyTerms.length === 0, 'input': true, 'is-danger': errors.has($t('texts.term')) }" :name="$t('texts.term')" v-validate="'required'">
                                          <option disabled value='' selected>{{ $t("buttons.select") }}</option>
                                          <!-- <option :value="new Date().getFullYear()(new Date().getMonth()).toString().padStart(2, '0')">2025/03</option> -->
                                          <option v-for='item in policyTerms' :value='item.value' :key='item.value'>{{ item.title }}</option>
                                        </select>
                                        <span class="help is-danger">{{ errors.first($t('texts.term')) }}</span>
                                      </div>
                                    </div>
                                  </template>
                                  <div class="column data-update-button">
                                    <button type="button" class="button is-primary is-fullwidth is-medium" @click="getAgencyPolicies(true)">Excel Olarak İndir</button>
                                  </div>
                                </div>
                              </modal>
                            <div class="item-text" v-on:click="openPolicyListPopUp(true)">Yenileme Listesi</div>
                          </div>
                          <div class="column is-2"><div><i class="fa fa-chevron-right"></i></div></div>
                        </div>
                      </div>
                    </div>
                  </el-popover>
                </div>
                <div class="column is-2"><div><i class="fa fa-chevron-right"></i></div></div>
              </div>
            </div>
            <div class="column is-12">
              <div class="columns">
                <div class="column is-2"><div class="clipboard-text-icon"></div></div>
                <div class="column is-8">
                  <a href="https://ap.eurekosigorta.com.tr/" alt="Eureko Sigorta Esgate" name="ESGate" target="_blank">
                    <div class="item-text">ESGate giriş</div>
                  </a>
                </div>
                <div class="column is-2"><div><i class="fa fa-chevron-right"></i></div></div>
              </div>
            </div>
            <div class="column is-12">
                <div class="columns">
                  <div class="column is-2"><div class="pencil-circle-icon"></div></div>
                  <div class="column is-8">
                    <router-link :to="{ name: 'AgencyEducation'}">
                      <div class="item-text">Eğitimler</div>
                    </router-link>
                  </div>
                  <div class="column is-2"><div><i class="fa fa-chevron-right"></i></div></div>
                </div>
              </div>
              <div class="column is-12">
                <div class="columns">
                  <div class="column is-2"><div class="megaphone-icon"></div></div>
                  <div class="column is-8">
                    <router-link :to="{ name: 'AgencyAnnouncement'}">
                      <div class="item-text">Duyurular</div>
                    </router-link>
                  </div>
                  <div class="column is-2"><div><i class="fa fa-chevron-right"></i></div></div>
                </div>
              </div>
              <div class="column is-12">
                <div class="columns">
                  <div class="column is-2"><div class="clipboard-text-icon"></div></div>
                  <div class="column is-8">
                    <router-link :to="{ name: 'AgencyForm'}">
                      <div class="item-text">Formlar</div>
                    </router-link>
                  </div>
                  <div class="column is-2"><div><i class="fa fa-chevron-right"></i></div></div>
                </div>
              </div>
            <div v-if="isAgencyLogin" class="column is-12">
              <div class="columns">
                <div class="column is-2"><div class="sliders-icon"></div></div>
                <div class="column is-8" v-on:click.stop="logOut($event)"><div class="item-text">Çıkış</div></div>
                <div class="column is-2"><div><i class="fa fa-chevron-right"></i></div></div>
              </div>
            </div>
          </div>
        </el-popover>
      </div>
    </div>
</template>
<script>
import service from '@/service'
import Popover from 'element-ui/lib/popover'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
// import ElButton from 'element-ui/lib/button'
import 'element-ui/lib/theme-chalk/index.css'
export default {
  components: {
    'el-popover': Popover
    // 'el-button': ElButton
  },
  data () {
    return {
      locationOrigin: '',
      parentVisible: false,
      childVisible: false,
      branch: '',
      term: '',
      branches: new Map(),
      terms: new Map(),
      policyTerms: [],
      policyTerm: '',
      customer: null,
      policyListShow: false,
      policyRenewalListShow: false,
      isRenewal: false,
      policyUpdateDate: '',
      policyList: [],
      agencyAuthorizations: null
    }
  },
  created: function () {
    this.eventHub.$on('agencyAuthorizationsReady', this.getAgencyAuthorizations)
  },
  beforeDestroy: function () {
    this.eventHub.$off('agencyAuthorizationsReady', this.getAgencyAuthorizations)
  },
  beforeMount () {
    this.locationOrigin = window.location.origin.toLocaleLowerCase()
  },
  mounted () {
    this.agencyAuthorizations = window.getAgencyAuthorizations()
  },
  computed: {
    envLogo: function () {
      var envlogoClass = ''
      if (this.isEnvTest) {
        envlogoClass = 'eureko-logo-blue-test'
      }
      if (this.isEnvPreProd) {
        envlogoClass = 'eureko-logo-blue-pre-prod'
      }

      return envlogoClass
    },
    isEnvTest: function () {
      return this.locationOrigin.includes('test')
    },
    isEnvPreProd: function () {
      return this.locationOrigin.includes('pre')
    },
    isEnvDev: function () {
      return this.locationOrigin.includes('localhost')
    },
    isEnvNotProd: function () {
      return this.isEnvTest || this.isEnvPreProd || this.isEnvDev
    },
    isAgencyLogin: function () {
      return this.isLogin() || this.$route.name === 'AgencyPersonal'
    },
    hasTransactionShow: function () {
      return (this.$route.path.includes('acente-bireysel-sube') || this.$route.path.includes('401')) && this.agencyAuthorizations != null
    },
    sortedTerms: function () {
      return Array.from(this.terms.entries()).sort((a, b) =>
        a[0].localeCompare(b[0])
      )
    },
    isPolicyRenewalListActive: function () {
      return !this.isEnvNotProd || (this.agencyAuthorizations != null && this.agencyAuthorizations.policyRenewalList)
    },
    isListDemandActive: function () {
      return this.isEnvNotProd && (this.agencyAuthorizations != null && this.agencyAuthorizations.listDemand)
    },
    isUploadDemandActive: function () {
      return this.isEnvNotProd && (this.agencyAuthorizations != null && this.agencyAuthorizations.uploadDemand)
    }
  },
  methods: {
    logOut: function () {
      var self = this
      var data = {
        logOut: true
      }
      service.access.logOut(self, self.eventHub, true, data).then(function (resp) {
        if (resp.ok) {
          var loginInfo = JSON.parse(resp.bodyText)
          if (loginInfo && loginInfo.ResultType === 0) {
            window.deleteLoginItems()
            self.removeCustomerInfo()
            setTimeout(function () {
              self.eventHub.$emit('logout', {
                value: true
              })
            }, 500)
            // window.close()
            this.$router.push({ name: 'HomePage' })
          }
        }
      })
    },
    getBranchesAndTerms: function (isRenewal) {
      var self = this
      self.isRenewal = isRenewal
      self.branches = new Map()
      self.terms = new Map()
      var storedCustomer = window.getCustomer()
      self.customer = storedCustomer
      var req = {
        AgencyNo: self.customer.agencyNo
      }
      service.customer.getAgencyBranchesAndTermsData(self, self.eventHub, true, req).then(function (resp) {
        if (resp.body && resp.body.ResultType === 0) {
          self.branchesAndTerms = resp.body.ReturnObject
          self.branchesAndTerms.forEach(function (item) {
            if (!self.branches.has(item.AgencyCode)) {
              self.branches.set(item.AgencyCode, item.AgencyName)
            }
            // if (!self.terms.has(item.Term)) {
            //   self.terms.set(item.Term, self.formatQuarterlyDate(item.Term))
            // }
          })
          // self.terms = self.sortedTerms
          if (isRenewal) {
            self.policyRenewalListShow = true
          } else {
            self.policyListShow = true
          }
          self.branch = ''
          self.policyTerm = ''
        }
      })
    },
    getAgencyPolicyTerms: function (isRenewal) {
      var self = this
      self.policyTerms = []
      self.policyTerm = ''
      self.policyUpdateDate = ''
      var req = {
        BranchName: self.branch === '99' ? self.customer.agencyNo : self.branch,
        IsRenewal: isRenewal
      }

      service.customer.getAgencyPolicyTerms(self, self.eventHub, true, req).then(function (resp) {
        if (resp.body && resp.body.ResultType === 0) {
          var policyTerms = resp.body.ReturnObject.agencyPolicyTermsInfo
          // self.policyUpdateDate = policyTerms.map(function (e) { return e.UpdateDate }).sort().reverse()[0]

          const latest = policyTerms.reduce((latest, current) => {
            const parseDate = str => {
              const [day, month, year] = str.split('-').map(Number)
              return new Date(year, month - 1, day)
            }

            return parseDate(current.UpdateDate) > parseDate(latest.UpdateDate)
              ? current
              : latest
          })
          self.policyUpdateDate = latest.UpdateDate
          policyTerms.forEach(function (item) {
            self.policyTerms.push({ title: self.formatQuarterlyDate(item.Term), value: item.Term })
          })
        }
      })
    },
    getAgencyPolicies: function (isRenewal) {
      var self = this
      self.isRenewal = isRenewal
      var req = {
        BranchName: self.branch === '99' ? self.customer.agencyNo : self.branch,
        Term: self.policyTerm,
        IsRenewal: self.isRenewal
      }
      service.customer.getAgencyPolicies(self, self.eventHub, true, req).then(function (resp) {
        if (resp.body && resp.body.ResultType === 0) {
          self.policyList = !self.isRenewal ? resp.body.ReturnObject.agencyPolicyInfo : resp.body.ReturnObject.agencyRenewalInfo
          self.exportToExcel(self.policyList)
        }
        if (isRenewal) {
          self.policyRenewalListShow = false
        } else {
          self.policyListShow = false
        }
      })
    },
    exportToExcel: function (json) {
      var self = this
      // JSON → Worksheet
      // const worksheet = XLSX.utils.json_to_sheet(json)
      var fileName = self.isRenewal ? `${self.branch === '99' ? self.customer.agencyNo : self.branch}_Nolu_Acente_Yenilemeleri.xlsx`
      : `${self.branch === '99' ? self.customer.agencyNo : self.branch}_Nolu_Acente_Policeleri.xlsx`
      var headers = self.isRenewal
                    ? [
                    'ACENTE GRUP KODU',
                    'VDP ACENTE KOD',
                    'VDP ACENTE AD',
                    'VDP POLICE NO',
                    'VDP YENILEME NO',
                    'VDP BASLAMA TARIH',
                    'VDP BITIS TARIH',
                    'VDP ANA URUN GRUBU',
                    'VDP ALT URUN GRUBU',
                    'VDP TARIFE KOD',
                    'VDP PRIM TL',
                    'VDP KOMISYON TL',
                    'VDP SIGORTALI ETTIREN NO',
                    'VDP MUST AD',
                    'VDP KIMLIK NO',
                    'VDP DOVIZ CINS',
                    'YENILEME DURUMU',
                    'VDP PLAKA NO',
                    'YENI DOVIZ CINS',
                    'ARAC MARKA',
                    'ARAC TIPI',
                    'ARAC MODELI',
                    'GUNCELLEME TARIH' ]
                  : [
                    'CARI DONEM',
                    'ACENTE KODU',
                    'ACENTE UNVANI',
                    'POLICE NO',
                    'YENILEME NO',
                    'ZEYL NO',
                    'ZEYL ADI',
                    'ARA ZEYL NO',
                    'REV NO',
                    'TANZIM TARIH',
                    'BASLAMA TARIH',
                    'BITIS TARIH',
                    'SIGORTALI KIMLIK NO',
                    'SIGORTALI VERGI NO',
                    'SIGORTALI AD SOYAD',
                    'SIGORTA ETTIREN KIMLIK NO',
                    'SIGORTA ETTIREN VERGI NO',
                    'SIGORTA ETTIREN AD SOYAD',
                    'TARIFE KOD',
                    'ANA URUN GRUBU',
                    'ALT URUN GRUBU',
                    'DOVIZ CINSI',
                    'DOVIZ CINSI NET PRIM',
                    'DOVIZ CINSI BRUT PRIM',
                    'DOVIZ CINSI KOMISYON',
                    'DOVIZ CINSI VERGI',
                    'POLICE ADET',
                    'TARIM SIGORTA ETTIREN NET PRIM TL',
                    'TARIM DD PRIM TL',
                    'NET PRIM TL',
                    'BRUT PRIM TL',
                    'VERG TL',
                    'KOMISYON TL'
                  ]
      const rows = json.map(r => Object.values(r))
      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows])

      headers.forEach((h, colIndex) => {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex }) // row:0, col:X
        if (!worksheet[cellAddress]) return

        worksheet[cellAddress].s = {
          fill: { fgColor: { rgb: '4F81BD' } }, // mavi arka plan
          font: { bold: true, color: { rgb: 'FFFFFF' } }, // bold + beyaz yazı
          alignment: { horizontal: 'center', vertical: 'center' } // ortalama
        }
      })
      // Worksheet → Workbook
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Veriler')

      // Excel dosyasını binary olarak yaz
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })

      // Kaydet
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' })
      saveAs(blob, fileName)
    },
    formatQuarterlyDate: function (term) {
      var year = term.slice(0, 4) // Get the first 4 characters as year
      var monthPart = term.slice(4, 6) // Get the last 2 characters as month

      return `${year}/${monthPart}`
    },
    openPolicyListPopUp: function (isRenewal) {
      this.getBranchesAndTerms(isRenewal)
    },
    getAgencyAuthorizations: function () {
      this.agencyAuthorizations = window.getAgencyAuthorizations()
    }
  },
  watch: {
    'branch': function () {
      this.getAgencyPolicyTerms(this.isRenewal)
    }
  }
}
</script>
<style>
#header {
  min-height: 50px;
  background-color: #273a7e;
}

#header .eureko-logo-white {
  width: 100px;
  height: 50px;
}

#header .logo {
  position: absolute;
  margin: 8px auto;
  left: 0;
  right: 0;
  z-index: 1;
}

#header .env {
  position: absolute;
  top: -5px;
}
#header .transactions .el-popover__reference {
  color: white;
}
#header .transactions .el-popover__reference-wrapper {
  position: absolute;
  right: 80px;
  top: 0;
  cursor: pointer;
}
.el-popover.el-popper .transaction-items {
  padding: 10px;
  margin-bottom: -10px;
}
#header .transactions .el-popover__reference-wrapper .fa {
  font-size: 14px;
  vertical-align: baseline;
  margin-left: 5px;
}
.el-popover.el-popper .transaction-items .fa {
  font-size: 10px;
  vertical-align: baseline;
  color: var(--dark-bg1);
}
.el-popover.el-popper .transaction-items .item-text {
  color: var(--dark-bg1);
  font-size: 14px;
  cursor: pointer;
}
#header .el-popover__reference-wrapper .button.is-primary:focus {
  background-color: #273a7e;
}
.modal .modal-card .agency-policy-list-modal-title {
  font-weight: 700;
  font-size: 15px;
}
.modal .modal-card .agency-policy-list-modal-desc {
  font-weight: 400;
  font-size: 14px;
}
.modal .modal-background {
  background-color: hsla(0, 0%, 4%, .3);
}
</style>


// WEBPACK FOOTER //
// src/shared/widget/ibranch/header.vue